import {
  HEADER_TITLE_TEXT,
} from '@sgcmpteltd/uikit-next/components/page-header/mobile';
import {
  HEADER_CONTENT_PAGE,
} from '@sgcmpteltd/uikit-next/components/page-header/mobile-v2';

import {
  joinSgcmMobileSite,
  joinSgcmMsSite,
  joinSgcmSite,
} from '@/utils/url/join/public';

import {
  PAGE_PROMOTIONS,
  PAGE_ROUTE_AD_LIST,
  PAGE_ROUTE_AD_PRICELISTS,
  PAGE_ROUTE_ALL_NEW_CARS_BRAND,
  PAGE_ROUTE_AUTHORISED_DISTRIBUTOR_LIST,
  PAGE_ROUTE_BEST_SELLING_CAR_MODELS,
  PAGE_ROUTE_CAR_MODELS,
  PAGE_ROUTE_COMPARE,
  PAGE_ROUTE_CONSUMERS_REVIEWS,
  PAGE_ROUTE_DEALER_LIST,
  PAGE_ROUTE_INFO,
  PAGE_ROUTE_LANDING,
  PAGE_ROUTE_LISTING,
  PAGE_ROUTE_LISTING_SEARCH_OPTION_PLACEHOLDER,
  PAGE_ROUTE_NEW_CAR_SHOWCASE,
  PAGE_ROUTE_PARALLEL_IMPORTED_CARS,
  PAGE_ROUTE_PARALLEL_IMPORTER_LIST,
  PAGE_ROUTE_PAST_CARS,
  PAGE_ROUTE_PI_LIST,
  PAGE_ROUTE_PRICELISTS,
  PAGE_ROUTE_PRICELISTS_PI_POPUP,
} from './constants';
import type { PageRegexConfigMap, PageRouteConfigMap } from './types';

export const pageRegexConfigMap: PageRegexConfigMap = {
  [PAGE_ROUTE_LANDING]: /^\/$/,
  [PAGE_ROUTE_LISTING]: /^\/listing(\/*.*)$/,
  [PAGE_ROUTE_COMPARE]: /^\/compare$/,
  [PAGE_ROUTE_INFO]: /^\/info\/\d+\/.+(?:\/pricing|photos|research|reviews|similar|promotions|accessories)?$/,
  [PAGE_ROUTE_ALL_NEW_CARS_BRAND]: /^\/all-new-cars-brand$/,
  [PAGE_ROUTE_PAST_CARS]: /^\/past-cars$/,
  [PAGE_ROUTE_NEW_CAR_SHOWCASE]: /^\/new-car-showcase$/,
  [PAGE_ROUTE_BEST_SELLING_CAR_MODELS]: /^\/best-selling-car-models$/,
  [PAGE_ROUTE_PRICELISTS]: /^\/pricelists$/,
  [PAGE_ROUTE_PRICELISTS_PI_POPUP]: /^\/pricelists\/pi-popup\/(\d+)\/(\d+)$/,
  [PAGE_ROUTE_AD_PRICELISTS]: /^\/pricelists\/(.+)\/(.+)$/,
  [PAGE_ROUTE_CONSUMERS_REVIEWS]: /^\/consumers-reviews$/,
  [PAGE_ROUTE_DEALER_LIST]: /^\/new-car-dealer-list$/,
  [PAGE_ROUTE_AD_LIST]: /^\/ad-list$/,
  [PAGE_ROUTE_PI_LIST]: /^\/pi-list$/,
  [PAGE_PROMOTIONS]: /^\/promotions$/,
  [PAGE_ROUTE_PARALLEL_IMPORTED_CARS]: /^\/singapore-parallel-imported-cars$/,
  [PAGE_ROUTE_PARALLEL_IMPORTER_LIST]: /^\/singapore-parallel-importer-list(?:\/\d+\/.+(?:\/pricelist|sales-team|service-centre)?)?$/,
  [PAGE_ROUTE_AUTHORISED_DISTRIBUTOR_LIST]: /^\/singapore-authorised-distributor-list$/,
  [PAGE_ROUTE_CAR_MODELS]: /^\/car-models\/[^#]+$/,
};

export const pageRouteConfigMap: PageRouteConfigMap = (
  searchParams,
  appContextValue,
) => ({
  [PAGE_ROUTE_LANDING]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMsSite('/').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: 'New Cars',
    },
  },
  [PAGE_ROUTE_LISTING]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: () => {
        const dealerId = searchParams.get('dealer_id');

        if (dealerId) {
          window.history.back();
        } else {
          window.location.href = joinSgcmMobileSite('/new_cars/index.php')
            .toString();
        }
      },
    },
    title: {
      type: 'search',
      searchOption: {
        defaultValue: (() => {
          if (typeof window === 'undefined') return undefined;
          const value = searchParams.get('q');

          return value || undefined;
        })(),
        placeholder: PAGE_ROUTE_LISTING_SEARCH_OPTION_PLACEHOLDER,
        onFocus: (e) => {
          appContextValue.setIsFilterModalOpen(true);
          setTimeout(() => {
            document.getElementById('advanced-search-input')?.focus();
          }, 100);
          e.target.blur();
        },
      },
    },
    onSubmit: (value) => {
      const href = new URL(window.location.href);

      href.searchParams.set('q', value);
      href.searchParams.delete('page');
      window.location.href = href.toString();
    },
  },
  [PAGE_ROUTE_COMPARE]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: () => {
        if (window !== undefined) {
          window.history.back();
        }
      },
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_INFO]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: () => {
        if (window !== undefined) {
          window.history.back();
        }
      },
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_ALL_NEW_CARS_BRAND]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMobileSite('/new_cars/index.php').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_PAST_CARS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_NEW_CAR_SHOWCASE]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_BEST_SELLING_CAR_MODELS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMobileSite('/new_cars/index.php').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_PRICELISTS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMobileSite('/new_cars/index.php').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_AD_PRICELISTS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/pricelists',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_CONSUMERS_REVIEWS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMobileSite('/new_cars/index.php').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_DEALER_LIST]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_AD_LIST]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_PI_LIST]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_PROMOTIONS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_PARALLEL_IMPORTED_CARS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMobileSite('/new_cars/PIdealer_listing.php')
        .toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_PARALLEL_IMPORTER_LIST]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/new-car-dealer-list',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_AUTHORISED_DISTRIBUTOR_LIST]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmSite('new_cars/newcars_dealer_landing.php').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_PRICELISTS_PI_POPUP]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: '/pricelists#pi',
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
  [PAGE_ROUTE_CAR_MODELS]: {
    app: {
      headerContent: HEADER_CONTENT_PAGE,
      goBackUrl: joinSgcmMobileSite('/new_cars/index.php').toString(),
    },
    title: {
      type: HEADER_TITLE_TEXT,
      content: '',
    },
  },
});
